import {connect} from "react-redux";

import ChatFormGoogleAdress from "../../../components/Chat/shared/ChatFormGoogleAdress/ChatFormGoogleAdress";

import {
    setChatBotMessageValue,
    setUserInfos,
} from "../../../actions/PlanDemand";
import {setAddressStripeInfos, setCityStripeInfos, setPostalCodeStripeInfos} from "../../../actions/stripePayment";

const MapStateToProps = (state) => ({
    messageValue: state.planDemand.messageValue,
});

const MapDispatchToProps = (dispatch) => ({
    setUserInfos: (value, type) => {
        dispatch(setUserInfos(value, type));
    },
    setChatBotMessageValue: (value) => {
        dispatch(setChatBotMessageValue(value));
    },
    setAddressStripeInfos: (address) => {
        dispatch(setAddressStripeInfos(address));
    },
    setCityStripeInfos: (city) => {
        dispatch(setCityStripeInfos(city));
    },
    setPostalCodeStripeInfos: (postalCode) => {
        dispatch(setPostalCodeStripeInfos(postalCode));
    },
});

export default connect(MapStateToProps, MapDispatchToProps)(ChatFormGoogleAdress);